import actions from './actions/index'
import getters from './getters/index'
import mutations from './mutations/index'

/**
 * The initial state
 *
 * @constant {object}
 */
const state = {
  extensions: [],
  groups: [],
  locations: [],
  mailboxes: [],
  menus: [],
  numbers: [],
  devices: [],
  recordings: [],
  routingProfiles: [],
  schedules: [],
  users: [],
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
